import {
  FETCHING_ACCOUNT,
  FETCHING_ACCOUNT_SUCCEEDED,
  FETCHING_ACCOUNT_FAILED,
  FETCHING_ACCOUNTS_REQUEST,
  FETCHING_ACCOUNTS_SUCCEEDED,
  FETCHING_ACCOUNTS_FAILED,
  UPDATING_ACCOUNT,
  UPDATING_ACCOUNT_SUCCEEDED,
  UPDATING_ACCOUNT_FAILED,
  UPDATING_ACCOUNT_SUBSCRIPTION,
  UPDATING_ACCOUNT_SUBSCRIPTION_SUCCEEDED,
  UPDATING_ACCOUNT_SUBSCRIPTION_FAILED,
  UPDATING_ACCOUNT_SETTINGS,
  UPDATING_ACCOUNT_SETTINGS_SUCCEEDED,
  UPDATING_ACCOUNT_SETTINGS_FAILED,
  UPDATING_SSO_CONFIGURATION,
  UPDATING_SSO_CONFIGURATION_SUCCEEDED,
  UPDATING_SSO_CONFIGURATION_FAILED,
  DELETING_ACCOUNT_REQUEST,
  DELETING_ACCOUNT_SUCCEEDED,
  DELETING_ACCOUNT_FAILED,
  UPDATING_CONTACT_DETAILS,
  UPDATING_CONTACT_DETAILS_SUCCEEDED,
  UPDATING_CONTACT_DETAILS_FAILED,
  UPDATING_ONBOARDING_DETAILS,
  UPDATING_ONBOARDING_DETAILS_SUCCEEDED,
  UPDATING_ONBOARDING_DETAILS_FAILED,
  FETCHING_ORDER_FORMS,
  FETCHING_ORDER_FORMS_SUCCEEDED,
  FETCHING_ORDER_FORMS_FAILED,
  UPLOADING_ORDER_FORM,
  UPLOADING_ORDER_FORM_SUCCEEDED,
  UPLOADING_ORDER_FORM_FAILED,
  DELETING_ORDER_FORM,
  DELETING_ORDER_FORM_SUCCEEDED,
  DELETING_ORDER_FORM_FAILED,
  INVALIDATE_ORDER_FORMS,
  DOWNLOADING_ORDER_FORM,
  DOWNLOADING_ORDER_FORM_SUCCEEDED,
  DOWNLOADING_ORDER_FORM_FAILED,
  FETCHING_SSO_CONFIGURATION,
  FETCHING_SSO_CONFIGURATION_SUCCEEDED,
  FETCHING_SSO_CONFIGURATION_FAILED,
  CHANGE_CURRENT_PRODUCT,
  FETCHING_LICENCE_COUNT,
  FETCHING_LICENCE_COUNT_SUCCEEDED,
  FETCHING_LICENCE_COUNT_FAILED,
  UPDATE_LICENCE_COUNT,
  UPDATE_LICENCE_COUNT_SUCCEEDED,
  UPDATE_LICENCE_COUNT_FAILED,
  FETCH_SUBSCRIPTION_PLAN,
  FETCH_SUBSCRIPTION_PLAN_SUCCEEDED,
  FETCH_SUBSCRIPTION_PLAN_FAILED,
  FETCH_AVAILABLE_PLANS,
  FETCH_AVAILABLE_PLANS_SUCCEEDED,
  FETCH_AVAILABLE_PLANS_FAILED,
  UPDATING_SUBSCRIPTION_TYPE,
  UPDATING_SUBSCRIPTION_TYPE_SUCCEEDED,
  UPDATING_SUBSCRIPTION_TYPE_FAILED,
  UPLOAD_CUSTOM_FONT,
  UPLOADING_CUSTOM_FONT_SUCCEEDED,
  UPLOADING_CUSTOM_FONT_FAILED,
  FETCHING_ACCOUNT_INTEGRATIONS,
  FETCHING_ACCOUNT_INTEGRATIONS_SUCCEEDED,
  FETCHING_ACCOUNT_INTEGRATIONS_FAILED
} from "constants/actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import _ from "lodash";

const API_URL = process.env.REACT_APP_API_URL;
const API_URL_V2 = process.env.REACT_APP_API_URL_V2;
const ACCOUNTS_BASE_URL = `${API_URL}/api/1.0/accounts`;
const ACCOUNTS_DASHBOARD_URL = `${API_URL_V2}/admin/accounts/3.0`;
const INTEGRATIONS_BASE_URL = `${API_URL}/api/1.0/integrations`;

/** fetch account */
export const fetchAccount = createAction(FETCHING_ACCOUNT);
const fetchingAccountSucceeded = createAction(FETCHING_ACCOUNT_SUCCEEDED);
const fetchingAccountFailed = createAction(FETCHING_ACCOUNT_FAILED);

/** fetch licence count */

export const fetchLicenceCount = createAction(FETCHING_LICENCE_COUNT);
const fetchingLicenceCountSucceeded = createAction(FETCHING_LICENCE_COUNT_SUCCEEDED);
const fetchingLicenceCountFaild = createAction(FETCHING_LICENCE_COUNT_FAILED);


export const updateLicenceCount = createAction(UPDATE_LICENCE_COUNT);
const updateLicenceCountSucceeded = createAction(UPDATE_LICENCE_COUNT_SUCCEEDED);
const updateLicenceCountFailed= createAction(UPDATE_LICENCE_COUNT_FAILED);

/** fetch subscription plan */
export const fetchSubscriptionPlan = createAction(FETCH_SUBSCRIPTION_PLAN);
const fetchSubscriptionPlanSucceeded = createAction(FETCH_SUBSCRIPTION_PLAN_SUCCEEDED);
const fetchSubscriptionPlanFaild = createAction(FETCH_SUBSCRIPTION_PLAN_FAILED);

/** fetch available subscription plan  */
export const fetchAvailablePlans = createAction(FETCH_AVAILABLE_PLANS);
const fetchAvailablePlansSucceeded = createAction(FETCH_AVAILABLE_PLANS_SUCCEEDED);
const fetchAvailablePlansFaild = createAction(FETCH_AVAILABLE_PLANS_FAILED);


function* fetchAccountSaga(action) {
  let { id } = action.payload;
  let url = buildUrl(ACCOUNTS_BASE_URL, { path: `${id}` });
  const fetchAccountAPI = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAccountAPI);
    yield put(fetchingAccountSucceeded(response));
  } catch (error) {
    yield put(fetchingAccountFailed(error));
  }
}

/** fetch licence count */

function* fetchLicenceCountSaga(action) {
  let accountId = _.get(action,'payload.account',null)
  if (accountId) {
    let url = buildUrl(ACCOUNTS_BASE_URL, { path: `${accountId}/licence/count` });
    const fetchLicenceAPI = async () => {
      return axios({
        method: "GET",
        url: url,
      }).then((response) => response.data);
    };
  

  try{
    const response = yield call(fetchLicenceAPI);
    yield put(fetchingLicenceCountSucceeded(response));
  }catch (error){
    yield put(fetchingLicenceCountFaild(error));
  }
}
}

/** update licence count */

function* updateLicenceCountSaga(action) {

  let { id,licenceCount } = action.payload;
  if (id && licenceCount) {
    let url = buildUrl(ACCOUNTS_BASE_URL, { path: `licence/${id}` });

    const updateLicenceAPI = async () => {
      return axios({
        method: "PUT",
        url: url,
        params: { licence: licenceCount }
      }).then((response) => response.data);
    };

  try {
    
    const response = yield call(updateLicenceAPI);
    yield put(updateLicenceCountSucceeded(licenceCount));
  } catch (error) {
    yield put(updateLicenceCountFailed(error));
  }
}
}



/** fetch accounts */
export const fetchAccounts = createAction(FETCHING_ACCOUNTS_REQUEST);
const fetchingAccountsSucceeded = createAction(
  FETCHING_ACCOUNTS_SUCCEEDED,
  (filters, response) => ({ filters, response })
);
const fetchingAccountsFailed = createAction(
  FETCHING_ACCOUNTS_FAILED,
  (filters, error) => ({ filters, error })
);

function* fetchAccountsSaga(action) {
  let { page, limit, filters } = action.payload;
  let url = buildUrl(ACCOUNTS_DASHBOARD_URL, { path: "/search" });
  const fetchAccountsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: { page, limit },
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAccountsAPI);
    yield put(fetchingAccountsSucceeded(filters, response));
  } catch (error) {
    yield put(fetchingAccountsFailed(filters, error));
  }
}

/** update account */
export const updateAccount = createAction(UPDATING_ACCOUNT);
const updatingAccountSucceeded = createAction(UPDATING_ACCOUNT_SUCCEEDED);
const updatingAccountFailed = createAction(UPDATING_ACCOUNT_FAILED);

function* updateAccountSaga(action) {

  let { id, data } = action.payload;
  let url = buildUrl(ACCOUNTS_BASE_URL, { path: `/${id}` });

  const updateAccountAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: data,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateAccountAPI);
    yield put(updatingAccountSucceeded(response));
  } catch (error) {
    yield put(updatingAccountFailed(error));
  }
}

// updating paperflite csm and finance contact
export const updateAccountContact = createAction(UPDATING_CONTACT_DETAILS);
const updateAccountContactSucceeded = createAction(UPDATING_CONTACT_DETAILS_SUCCEEDED);
const updateAccountContactFailed = createAction(UPDATING_CONTACT_DETAILS_FAILED);

function* updateAccountContactSaga(action) {
  let url = buildUrl(ACCOUNTS_BASE_URL, { path: `/${action.payload.id}/contact` });

  const updateCSM = () => {
    return axios({
      method: "PUT",
      data: action.payload.data,
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCSM);
    yield put(updateAccountContactSucceeded(response));
  } catch (error) {
    yield put(updateAccountContactFailed(error));
  }
}

// updating onboarding details

export const updateOnboardingDetails = createAction(UPDATING_ONBOARDING_DETAILS);
const updateOnboardingDetailsSucceeded = createAction(UPDATING_ONBOARDING_DETAILS_SUCCEEDED);
const updateOnboardingDetailsFailed = createAction(UPDATING_ONBOARDING_DETAILS_FAILED);

function* updateOnboardingDetailsSaga(action) {

  let url = buildUrl(ACCOUNTS_BASE_URL, { path: `/${action.payload.id}/onboarding` });

  const updateOnboarding = () => {
    return axios({
      method: "PUT",
      data: action.payload.data,
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateOnboarding);
    yield put(updateOnboardingDetailsSucceeded(response));
  } catch (error) {
    yield put(updateOnboardingDetailsFailed(error));
  }
}


/** update account subscription */
export const updateAccountSubscription = createAction(
  UPDATING_ACCOUNT_SUBSCRIPTION
);
const updatingAccountSubscriptionSucceeded = createAction(
  UPDATING_ACCOUNT_SUBSCRIPTION_SUCCEEDED
);
const updatingAccountSubscriptionFailed = createAction(
  UPDATING_ACCOUNT_SUBSCRIPTION_FAILED
);

function* updateAccountSubscriptionSaga(action) {
  let { id, subscription } = action.payload;

  let url = buildUrl(ACCOUNTS_BASE_URL, { path: `${id}/subscription` });
  const updateAccountSubscriptionAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: subscription,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateAccountSubscriptionAPI);
    yield put(updatingAccountSubscriptionSucceeded(response));
  } catch (error) {
    yield put(updatingAccountSubscriptionFailed(error));
  }
}


/** update account features */
export const updateAccountSettings = createAction(UPDATING_ACCOUNT_SETTINGS);
const updatingAccountSettingsSucceeded = createAction(
  UPDATING_ACCOUNT_SETTINGS_SUCCEEDED
);
const updatingAccountSettingsFailed = createAction(
  UPDATING_ACCOUNT_SETTINGS_FAILED
);

function* updateAccountSettingsSaga(action) {
  let { id, settings } = action.payload;
  let url = buildUrl(ACCOUNTS_BASE_URL, { path: `${id}/settings` });
  const updateAccountSettingsAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: settings,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateAccountSettingsAPI);
    yield put(updatingAccountSettingsSucceeded(response));
  } catch (error) {
    yield put(updatingAccountSettingsFailed(error));
  }
}

/** update sso configuration */
export const updateSSOConfiguration = createAction(UPDATING_SSO_CONFIGURATION);
const updatingSSOConfigurationSucceeded = createAction(
  UPDATING_SSO_CONFIGURATION_SUCCEEDED
);
const updatingSSOConfigurationFailed = createAction(
  UPDATING_SSO_CONFIGURATION_FAILED
);

function* updatingSSOConfigurationSaga(action) {
  let { id, ssoConfiguration } = action.payload;

  let url = buildUrl(ACCOUNTS_BASE_URL, { path: `${id}/sso-configuration` });
  const updatingSSOConfigurationAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: ssoConfiguration,
    }).then((response) => response.data);
  };
  try {
    const response = yield call(updatingSSOConfigurationAPI);
    yield put(updatingSSOConfigurationSucceeded(response));
  } catch (error) {
    yield put(updatingSSOConfigurationFailed(error));
  }
}

/** delete account */
export const deleteAccount = createAction(DELETING_ACCOUNT_REQUEST);
const deletingAccountSucceeded = createAction(DELETING_ACCOUNT_SUCCEEDED);
const deletingAccountFailed = createAction(DELETING_ACCOUNT_FAILED);

function* deleteAccountSaga(action) {
  let { id } = action.payload;
  let url = buildUrl(ACCOUNTS_BASE_URL, { path: `${id}` });
  const deleteAccountSettingsAPI = () => {
    return axios({
      method: "DELETE",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteAccountSettingsAPI);
    yield put(deletingAccountSucceeded(response));
  } catch (error) {
    yield put(deletingAccountFailed(error));
  }
}

// getting order forms

export const getOrderForms = createAction(FETCHING_ORDER_FORMS);
const getingOrderFormsSucceeded = createAction(FETCHING_ORDER_FORMS_SUCCEEDED);
const gettingOrderFormsFailed = createAction(FETCHING_ORDER_FORMS_FAILED);


function* getOrderFormsSaga(action) {
    let url = buildUrl(ACCOUNTS_BASE_URL, { path: `/${action.payload.id}/order-forms` });
    const updateOnboarding = () => {
        return axios({
            method: "GET",
            url: url,
        }).then((response) => response.data);
    };

    try {
        const response = yield call(updateOnboarding);
        yield put(getingOrderFormsSucceeded(response));
    } catch (error) {
        yield put(gettingOrderFormsFailed(error));
    }
}

// uploading order forms

export const uploadOrderForm = createAction(UPLOADING_ORDER_FORM);
const uploadingOrderFormSucceeded = createAction(UPLOADING_ORDER_FORM_SUCCEEDED);
const uploadingOrderFormFailed = createAction(UPLOADING_ORDER_FORM_FAILED);


function* uploadOrderFormSaga(action) {
    let url = buildUrl(ACCOUNTS_BASE_URL, { path: `/${action.payload.id}/order-forms` });

    var fileFormData = new FormData();
    fileFormData.append('file', action.payload.file);

    const updateOnboarding = () => {
        return axios({
            method: "POST",
            url: url,
            params: { date: action.payload.date },
            data: fileFormData
        }).then((response) => response.data);
    };

    try {
        const response = yield call(updateOnboarding);
        yield put(uploadingOrderFormSucceeded(response));
    } catch (error) {
        yield put(uploadingOrderFormFailed(error));
    }
}
/** fetch subscription plan */

function* fetchSubscriptionPlanSaga(action) {

  let accountId = _.get(action,'payload.account',null)
  if (accountId) {
    let url = buildUrl(ACCOUNTS_BASE_URL, { path: `${accountId}/subscription-plan` });
    const fetchSubscriptionAPI = async () => {
      return axios({
        method: "GET",
        url: url,
        params: { key: action.payload.key },
      }).then((response) => response.data);
    };
  

  try{
    const response = yield call(fetchSubscriptionAPI);
    yield put(fetchSubscriptionPlanSucceeded(response));
  }catch (error){
    yield put(fetchSubscriptionPlanFaild(error));
  }
}
}

/** fetch available subscription plan  */

function* fetchAvailablePlansSaga(action) {
    let url = buildUrl(ACCOUNTS_BASE_URL, { path: '/subscription-plan/all' });
    const fetchSubscriptionAPI = async () => {
      return axios({
        method: "GET",
        url: url,  
      }).then((response) => response.data);
    };


  try{
    const response = yield call(fetchSubscriptionAPI);
    yield put(fetchAvailablePlansSucceeded(response));
  }catch (error){
    yield put(fetchAvailablePlansFaild(error));
  }
}

/** updating plan */
export const updatingSubscriptionType = createAction(
  UPDATING_SUBSCRIPTION_TYPE
);
const updatingSubscriptionTypeSucceeded = createAction(
  UPDATING_SUBSCRIPTION_TYPE_SUCCEEDED
);
const updatingSubscriptionTypeFailed = createAction(
  UPDATING_SUBSCRIPTION_TYPE_FAILED
);

function* updatingSubscriptionTypeSaga(action) {
  let accountId = _.get(action, "payload.accountId", null);
  let licence = _.get(action, "payload.licenceCount",null);
  let subscriptionPlan = _.get(action, "payload.subscriptionPlan",null);
  let starterLicence = _.get(action, "payload.starterLicence", null);

  if (accountId) {
    let url = buildUrl(ACCOUNTS_BASE_URL, {path: `${accountId}/subscription-plan`});

    const planData = {
      subscriptionPlan,
      licence,
      starterLicence
    };
    const updatingSubscriptionTypeAPI = async () => {
      const response = await axios({
        method: "PUT",
        data: planData,
        url: url,
      });
      return response.data;
    };


    try {

      const response = yield call(updatingSubscriptionTypeAPI);
      yield put(updatingSubscriptionTypeSucceeded(licence));
    } catch (error) {
      yield put(updatingSubscriptionTypeFailed(error));
    }
  }
}


// deleting order form

export const deleteOrderForm = createAction(DELETING_ORDER_FORM);
const deletingOrderFormSucceeded = createAction(DELETING_ORDER_FORM_SUCCEEDED);
const deletingOrderFormFailed = createAction(DELETING_ORDER_FORM_FAILED);

function* deleteOrderFormSaga(action) {
    let url = buildUrl(ACCOUNTS_BASE_URL, { path: `/${action.payload.id}/order-forms/${action.payload.orderFormId}` });
    const deleteOrderForm = () => {
        return axios({
            method: "DELETE",
            url
        }).then((response) => response.data);
    };

    try {
        const response = yield call(deleteOrderForm);
        yield put(deletingOrderFormSucceeded(response));
    } catch (error) {
        yield put(deletingOrderFormFailed(error));
    }
}

//fetching SSO 
export const fetchingSSOConfiguration = createAction(FETCHING_SSO_CONFIGURATION);
const fetchingSSOConfigurationSucceeded = createAction(
  FETCHING_SSO_CONFIGURATION_SUCCEEDED
);
const fetchingSSOConfigurationFailed = createAction(
  FETCHING_SSO_CONFIGURATION_FAILED
);
function* fetchingSSOConfigurationSaga(action) {
  
  let { id } = action.payload;
  
  let url = buildUrl(ACCOUNTS_BASE_URL, { path: `${id}/fetch_sso` });
  const fetchingSSOConfigurationAPI = () => {
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };
  try {
    const response = yield call(fetchingSSOConfigurationAPI);
    yield put(fetchingSSOConfigurationSucceeded(response));
  } catch (error) {
    yield put(fetchingSSOConfigurationFailed(error));
  }
}
export const invalidateOrderForms = createAction(INVALIDATE_ORDER_FORMS)
 export const changeCurrentProduct = createAction(CHANGE_CURRENT_PRODUCT)

export const uploadCustomFont = createAction(UPLOAD_CUSTOM_FONT)
const uploadCustomFontSucceeded = createAction(UPLOADING_CUSTOM_FONT_SUCCEEDED);
const uploadCustomFontFailed = createAction(UPLOADING_CUSTOM_FONT_FAILED);

function* uploadCustomFontSaga(action) {
  let { accountId, file } = action.payload;

  let fileFormData = new FormData();
  fileFormData.append('file', file);

  let url = buildUrl(ACCOUNTS_BASE_URL, { path: `/upload-font/${accountId}` });
  const uploadCustomFontAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: fileFormData,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(uploadCustomFontAPI);
    yield put(uploadCustomFontSucceeded(response));
  } catch (error) {
    yield put(uploadCustomFontFailed(error));
  }
}
/*fetching account integrations */

export const fetchAccountIntegrations = createAction(FETCHING_ACCOUNT_INTEGRATIONS);
const fetchAccountIntegrationsSucceeded = createAction(FETCHING_ACCOUNT_INTEGRATIONS_SUCCEEDED);
const fetchAccountIntegrationsFailed = createAction(FETCHING_ACCOUNT_INTEGRATIONS_FAILED);

function* fetchAccountIntegrationsSaga(action) {

  let { id, page, limit} = action.payload;

  const url = buildUrl(INTEGRATIONS_BASE_URL, {
    path: `/${id}` ,
    queryParams: {
      page: page,
      limit: limit
    }
  });

  const fetchAccountIntegrationsAPI = () => {
    return axios({
      method: 'GET',
      url: url.toString(),
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAccountIntegrationsAPI);
    yield put(fetchAccountIntegrationsSucceeded(response));
  } catch (error) {
    yield put(fetchAccountIntegrationsFailed(error));
  }
}


export default function* accountsSaga() {
  yield takeLatest(FETCHING_ACCOUNT, fetchAccountSaga);
  yield takeLatest(FETCHING_ACCOUNTS_REQUEST, fetchAccountsSaga);
  yield takeLatest(UPDATING_ACCOUNT, updateAccountSaga);
  yield takeLatest(UPDATING_CONTACT_DETAILS, updateAccountContactSaga);
  yield takeLatest(UPDATING_ONBOARDING_DETAILS, updateOnboardingDetailsSaga);
  yield takeLatest(UPDATING_ACCOUNT_SUBSCRIPTION, updateAccountSubscriptionSaga);
  yield takeLatest(UPDATING_ACCOUNT_SETTINGS, updateAccountSettingsSaga);
  yield takeLatest(UPDATING_SSO_CONFIGURATION, updatingSSOConfigurationSaga);
  yield takeLatest(DELETING_ACCOUNT_REQUEST, deleteAccountSaga);
  yield takeLatest(FETCHING_ORDER_FORMS, getOrderFormsSaga);
  yield takeLatest(UPLOADING_ORDER_FORM, uploadOrderFormSaga);
  yield takeLatest(DELETING_ORDER_FORM, deleteOrderFormSaga);
  yield takeLatest(FETCHING_SSO_CONFIGURATION, fetchingSSOConfigurationSaga);
  yield takeLatest(FETCHING_LICENCE_COUNT,fetchLicenceCountSaga);
  yield takeLatest(UPDATE_LICENCE_COUNT,updateLicenceCountSaga);
  yield takeLatest(FETCH_SUBSCRIPTION_PLAN,fetchSubscriptionPlanSaga);
  yield takeLatest(FETCH_AVAILABLE_PLANS,fetchAvailablePlansSaga);
  yield takeLatest(UPDATING_SUBSCRIPTION_TYPE,updatingSubscriptionTypeSaga)
  yield takeLatest(UPLOAD_CUSTOM_FONT, uploadCustomFontSaga)
  yield takeLatest(FETCHING_ACCOUNT_INTEGRATIONS, fetchAccountIntegrationsSaga)
}
